import { createAction, props } from '@ngrx/store';
import { User } from '../../../shared/models/user.model';
import { LanguageEnum } from '../../../shared/enums/language.enum';
import { UnitSystem } from '../../../shared/enums/unitSystem.enum';
import { DietaryRequirement } from '../../../shared/enums/dietaryRequirementEnum';
import { UserRole } from '../../../shared/enums/userRole.enum';


export const loadUser = createAction('[User] Load User', props<{ userId: number }>());
export const loadUserSuccess = createAction('[User] Load User Success', props<{ user: User }>());
export const loadUserFailure = createAction('[User] Load User Failure', props<{ error: any }>());
export const clearUser = createAction('[User] Clear User');

export const updateUserPreferences = createAction(
  '[User] Update Preferences',
  props<{
    preferred_language: LanguageEnum;
    preferred_dietary: DietaryRequirement[];
    preferred_unit_system: UnitSystem;
    preferred_timezone?: string;
  }>()
);

export const updateUserPreferencesSuccess = createAction(
  '[User] Update Preferences Success',
  props<{ updatedPreferences: { preferred_language: LanguageEnum; preferred_dietary: DietaryRequirement[]; preferred_unit_system: UnitSystem; preferred_timezone?: string } }>()
);

export const updateUserPreferencesFailure = createAction(
  '[User] Update Preferences Failure',
  props<{ error: any }>()
);

// --- updated profile ---
export const updateUserProfile = createAction(
  '[User] Update User Profile',
  props<{ name: string }>()
);
export const updateUserProfileSuccess = createAction(
  '[User] Update Profile Success',
  props<{ user: Partial<User> }>()
);
export const updateUserProfileFailure = createAction(
  '[User] Update User Profile Failure',
  props<{ error: any }>()
);

// --- update email ---
export const updateUserEmail = createAction(
  '[User] Update User Email',
  props<{ email: string }>()
);
export const updateUserEmailSuccess = createAction(
  '[User] Update User Email Success',
  props<{ user: User }>()
);
export const updateUserEmailFailure = createAction(
  '[User] Update User Email Failure',
  props<{ error: any }>()
);

// --- update password ---
export const updateUserPassword = createAction(
  '[User] Update User Password',
  props<{ currentPassword: string; newPassword: string }>()
);
export const updateUserPasswordSuccess = createAction(
  '[User] Update User Password Success'
);
export const updateUserPasswordFailure = createAction(
  '[User] Update User Password Failure',
  props<{ error: any }>()
);

export const deleteUserAccount = createAction('[User] Delete Account');
export const deleteUserAccountSuccess = createAction('[User] Delete Account Success');
export const deleteUserAccountFailure = createAction('[User] Delete Account Failure', props<{ error: any }>());

export const updateUserRole = createAction(
  '[User] Update User Role',
  props<{ username: string; role: UserRole }>()
);

export const updateUserRoleSuccess = createAction(
  '[User] Update User Role Success',
  props<{ username: string; role: UserRole; message: string }>()
);

export const updateUserRoleFailure = createAction(
  '[User] Update User Role Failure',
  props<{ error: any }>()
);

export const updateUserOnboardingStatus = createAction(
  '[User] Update Onboarding Status',
  props<{ onboarding_complete: boolean }>()
);

export const updateUserOnboardingStatusSuccess = createAction(
  '[User] Update Onboarding Status Success',
  props<{ onboarding_complete: boolean }>()
);

export const updateUserOnboardingStatusFailure = createAction(
  '[User] Update Onboarding Status Failure',
  props<{ error: any }>()
);

export const completeOnboarding = createAction(
  '[User] Complete Onboarding',
  props<{
    preferred_language: LanguageEnum;
    preferred_dietary: DietaryRequirement[];
    preferred_unit_system: UnitSystem;
    onboarding_complete: boolean;
    name: string;
  }>()
);

export const loadUserCount = createAction('[Admin] Load User Count');
export const loadUserCountSuccess = createAction('[Admin] Load User Count Success', props<{ count: number }>());
export const loadUserCountFailure = createAction('[Admin] Load User Count Failure', props<{ error: any }>());

export const loadAllUsers = createAction('[Admin] Load All Users');
export const loadAllUsersSuccess = createAction('[Admin] Load All Users Success', props<{ users: User[] }>());
export const loadAllUsersFailure = createAction('[Admin] Load All Users Failure', props<{ error: any }>());

export const updateMarketplaceSubscription = createAction(
  '[User] Update Marketplace Subscription',
  props<{ subscribed: boolean }>()
);

export const updateMarketplaceSubscriptionSuccess = createAction(
  '[User] Update Marketplace Subscription Success',
  props<{ marketplace_subscribed: boolean; marketplace_subscribed_at: string | null }>()
);

export const updateMarketplaceSubscriptionFailure = createAction(
  '[User] Update Marketplace Subscription Failure',
  props<{ error: any }>()
);

export const loadLinkedAccounts = createAction('[User] Load Linked Accounts');
export const loadLinkedAccountsSuccess = createAction(
  '[User] Load Linked Accounts Success',
  props<{ accounts: { provider: string; created_at: string }[] }>()
);
export const loadLinkedAccountsFailure = createAction(
  '[User] Load Linked Accounts Failure',
  props<{ error: any }>()
);

